<template>
  <div class="hospital-db-layout-footer">
      <footer-bottom></footer-bottom>
  </div>
</template>

<script>
import FooterBottom from "../../components/wordbench/footer.vue";
export default {
    components: { FooterBottom },

}
</script>

<style>

</style>